export default {"src":"/_next/static/media/logo-refinitiv-vector-white.25579705.svg","height":83,"width":410,"blurWidth":0,"blurHeight":0};